<template>
  <div class="d-flex align-items-baseline">
    <label for="" class="font-weight-bold text-white text-sm me-3 custom-select">
      {{ $t('student') }}
    </label>
    <select
      class="form-control form-control-sm"
      name="student-manager"
      required
      id="select-student-manager"
      v-model="state.studentId"
      @change="setStudentManager()"
    >
      <option value="">{{ $t('selectStudent') }}</option>
      <option v-for="(item, index) in state.alunos" :key="index" :value="item.id">
        {{ item.name }} {{ item.surname }}
      </option>
    </select>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, watch } from 'vue'
import { useStore } from 'vuex'
import alunoRepository from '../../services/api/alunoRepository'
import planosTreinoRepository from '../../services/api/planosTreinoRepository'
export default {
  setup() {
    const store = useStore()
    const swal = inject('$swal')

    const state = reactive({
      studentId: '',
      alunos: [],
    })

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      if (store.getters.StudentManager != null) {
        state.studentId = store.getters.StudentManager
      }

      listarAlunos()
    })

    const listarAlunos = () => {
      alunoRepository
        .AlunoGet()
        .then((response) => {
          state.alunos = []
          if (response.data.success) {
            state.alunos = response.data.data
          }
        })
        .catch((error) => {
          console.error(error)
          // Silenciosamente ignora o erro de listagem de alunos
          // pois pode ser erro de permissão ou coach sem alunos
        })
    }

    const setStudentManager = async () => {
      let id = parseInt(state.studentId)
      store.commit('SET_STUDENT', id > 0 ? id : null)

      // Se um aluno foi selecionado, buscar o plano de treino ativo
      if (id > 0) {
        try {
          const response = await planosTreinoRepository.PlanosTreinoGet({
            headers: {
              'student-manager': id
            }
          })

          if (response.data.success && response.data.data) {
            const planos = Array.isArray(response.data.data) ? response.data.data : [response.data.data]

            if (planos.length > 0) {
              // Prioridade:
              //  1) Plano que cobre HOJE (initial_date <= hoje <= final_date)
              //  2) Plano com maior final_date (mais futuro)
              //  3) Ultimo criado (fallback)
              const hoje = new Date().toISOString().split('T')[0]
              const onlyDate = (d) => (d ? String(d).split(' ')[0].split('T')[0] : null)

              const cobreHoje = planos.filter((p) => {
                const ini = onlyDate(p.initial_date)
                const fim = onlyDate(p.final_date)
                return ini && ini <= hoje && (!fim || fim >= hoje)
              })

              let escolhido = null
              if (cobreHoje.length > 0) {
                // Se mais de um cobrir, escolhe o com final_date mais tarde
                escolhido = cobreHoje.sort((a, b) =>
                  String(b.final_date || '').localeCompare(String(a.final_date || ''))
                )[0]
              } else {
                // Nenhum cobre hoje - pega o com final_date mais tarde no futuro
                const futuros = planos
                  .filter((p) => onlyDate(p.final_date) >= hoje)
                  .sort((a, b) =>
                    String(a.final_date || '').localeCompare(String(b.final_date || ''))
                  )
                escolhido = futuros[0] || planos
                  .slice()
                  .sort((a, b) =>
                    String(b.final_date || '').localeCompare(String(a.final_date || ''))
                  )[0]
              }

              store.commit('SET_TRAINING_PLAN', escolhido.id)
              console.log('[SelecionaAluno] Plano escolhido:', escolhido.id, escolhido.name, escolhido.initial_date, '->', escolhido.final_date)
            } else {
              store.commit('SET_TRAINING_PLAN', null)
            }
          } else {
            store.commit('SET_TRAINING_PLAN', null)
          }
        } catch (error) {
          console.error('Erro ao buscar plano de treino:', error)
          store.commit('SET_TRAINING_PLAN', null)
        }
      } else {
        store.commit('SET_TRAINING_PLAN', null)
      }

      window.location.reload()
    }
    return {
      state,
      setStudentManager,
    }
  },
}
</script>

<style></style>
